import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ss-tela-conteudo" }
const _hoisted_8 = { class: "ss-card ss-card-space" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_consulta_produtos = _resolveComponent("consulta-produtos")!
  const _component_disponibilidade_produtos = _resolveComponent("disponibilidade-produtos")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_titulo_padrao, {
            identificadorRecurso: "POSICAO_ESTOQUE",
            tituloRecurso: "Posição de Estoque",
            exibirAtalhosTela: true,
            exibirHistoricoTela: true,
            empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
            "onUpdate:empresasSelecionadas": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
          }, {
            BotoesAcoes: _withCtx(() => [
              _createElementVNode("div", {
                class: "ss-principais-acoes",
                style: _normalizeStyle(_ctx.storeSistema.state.layoutMobile ? 'margin-left: auto; margin-right: auto;' : '')
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.state.tipoVisualizacao === 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-primary ss-btn-tela",
                          title: "Consulta de Produtos",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alterarVisualizacao(0)))
                        }, [
                          _createVNode(_component_icone, { nome: "pesquisar" })
                        ]),
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Posição Geral",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.alterarVisualizacao(1)))
                        }, [
                          _createVNode(_component_icone, { nome: "imprimir" })
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-secondary ss-btn-recursos",
                          title: "Consulta de Produtos",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.alterarVisualizacao(0)))
                        }, [
                          _createVNode(_component_icone, { nome: "pesquisar" })
                        ]),
                        _createElementVNode("button", {
                          class: "ant-btn ant-btn-primary ss-btn-tela",
                          title: "Posição Geral",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.alterarVisualizacao(1)))
                        }, [
                          _createVNode(_component_icone, { nome: "imprimir" })
                        ])
                      ], 64))
                ])
              ], 4)
            ]),
            _: 1
          }, 8, ["empresasSelecionadas"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createVNode(_component_selecionar_empresa, {
                codigoSelecionado: _ctx.state.empresa,
                "onUpdate:codigoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.empresa) = $event)),
                empresasEspecificas: _ctx.telaBase.empresasDisponiveis
              }, null, 8, ["codigoSelecionado", "empresasEspecificas"]), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              (_ctx.state.tipoVisualizacao === 0)
                ? (_openBlock(), _createBlock(_component_consulta_produtos, {
                    key: 0,
                    empresa: _ctx.state.empresa,
                    "tipo-selecao": 1,
                    controles: _ctx.state.controles,
                    "onUpdate:controles": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.controles) = $event)),
                    produtos: _ctx.state.produtos,
                    "onUpdate:produtos": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.produtos) = $event))
                  }, null, 8, ["empresa", "controles", "produtos"]))
                : (_openBlock(), _createBlock(_component_disponibilidade_produtos, {
                    key: 1,
                    empresa: _ctx.state.empresa,
                    controles: _ctx.state.controles,
                    "onUpdate:controles": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.controles) = $event))
                  }, null, 8, ["empresa", "controles"]))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ], 64))
}